export default "__VITE_ASSET__BbRY8lLg__"